import { useDispatch } from 'react-redux';
import { loadDataSource, updateSourceInfo } from 'js/actions';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import useAppDispatch from 'js/hooks/useAppDispatch';

export default function useSourcesAdapter() {
  const dispatch = useAppDispatch();

  function requestSourceById({ id, ignoreErrors = false, aclQueryMode }) {
    return dispatch(loadDataSource(id, { aclQueryMode, ignoreErrors }));
  }

  function requestUpdateSourceById(id: number, sourceInfo: any) {
    return dispatch(updateSourceInfo(id, sourceInfo));
  }

  async function getSourceById(id: any, fullResponse = false) {
    const response = await requestSourceById({
      id,
      ignoreErrors: false,
      aclQueryMode: ACLQueryModeTypes.MODE_COLLABORATOR.key,
    });
    if (fullResponse) {
      return response;
    }
    return response?.entities?.sources?.[id];
  }

  return {
    getSourceById,
    requestSourceById,
    requestUpdateSourceById,
  };
}
